import { refundGenieApiLink } from "@/core/apiLink";
import { baseFetch, getUrlWithSearchParams } from "@helium10/re-core";

type IErrorResponse = {
  errorCode: number;
  errors: Record<string, string[]>;
  message: string;
};

export type IRefundGenieAccessResponse = {
  code: number;
  message: string;
  data: {
    apiTokenBind: boolean;
    reportEnable: boolean;
  };
} & IErrorResponse;

export const checkRefundGenieAccess = async () => {
  return baseFetch<void, IRefundGenieAccessResponse>({
    url: getUrlWithSearchParams(`${refundGenieApiLink}/report/access`, {}),
    method: "GET",
    useSessionAccountId: true,
  });
};
